import { mount } from './dom-lifecycle';

// Initialise the hamburger / slide-out panel on any page that includes
// the _game-menu.html.twig partial.
// The `gameBound` guard prevents double-binding if the node is re-mounted.
mount('#js-game-menu', function (btn) {
    if (btn.dataset.gameBound) return;
    btn.dataset.gameBound = '1';

    const overlay = document.getElementById('js-game-overlay');

    btn.addEventListener('click', function () {
        const open = this.classList.toggle('is-open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (overlay) {
            overlay.classList.toggle('is-open', open);
            overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
    });

    if (overlay) {
        overlay.addEventListener('click', function (e) {
            if (!e.target.closest('.s-game__panel')) {
                btn.click();
            }
        });
    }
});
